<template>
  <div class="content-container">
    <el-form ref="form" :model="form" label-width="100px" class="mate-form" hide-required-asterisk label-position="left">
      <ContentBox title="基本信息" class="content-box">
        <el-row>
          <el-col :span="14">
            <el-form-item label="物料名称" prop="materialName" :rules="[{ required: true, message: '请输入素材名称', trigger: 'blur' }]">
              <el-input v-model.trim="form.materialName" v-noEmoji maxlength="45" show-word-limit placeholder="请输入物料名称"></el-input>
            </el-form-item>
            <el-form-item label="广告位" prop="spaceId" :rules="[{ required: true, message: '请选择广告位', trigger: 'change' }]">
              <el-select v-model="form.spaceId" placeholder="请选择广告位" clearable filterable @change="handleChangeSpace">
                <el-option v-for="item in spaceList" :key="item.spaceId" :label="item.spaceName" :value="item.spaceId"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="描述">
              <el-input type="textarea" :rows="4" v-model.trim="form.description" v-noEmoji show-word-limit maxlength="50"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </ContentBox>
      <ContentBox v-show="form.spaceId" title="物料上传" class="content-box">
        <el-row>
          <el-col :span="14">
            <el-form-item
              v-for="(item, index) in form.materialPackageList"
              :key="index"
              :label="item.name"
              :prop="'materialPackageList.' + index + '.value'"
              :rules="item.checkRules"
            >
              <!-- 文字 -->
              <template v-if="item.type === 'text'">
                <el-input v-model="item.value" :placeholder="item.placeholder"></el-input>
              </template>
              <template v-if="['single_select', 'multi_select'].includes(item.type)">
                <el-select v-model="item.value" clearable :placeholder="item.placeholder" :multiple="item.type === 'multi_select'">
                  <el-option v-for="(op, idx) in item.options" :key="idx" :value="op.value" :label="op.label"></el-option>
                </el-select>
              </template>
              <!-- 图片/视频/压缩文件 -->
              <template v-if="['image', 'video', 'zip'].includes(item.type)">
                <div v-if="item.status === 'uploading'" class="mate-upload-box">
                  <div class="mate-progress">
                    <el-progress :width="120" type="circle" :percentage="item.percentage"></el-progress>
                  </div>
                </div>
                <el-upload
                  v-else
                  class="mate-upload-box"
                  action="#"
                  element-loading-text="上传中，请稍后……"
                  :accept="item.format"
                  :show-file-list="false"
                  :http-request="(file) => { uploadFile(file, item) }"
                  :before-upload="(file) => { return beforeUploadFile(file, item) }"
                >
                  <template v-if="item.value">
                    <div class="img-box">
                      <div class="show-img-box">
                        <el-image :src="item.type === 'image' ? item.value : defaultImg" contain lazy></el-image>
                        <span class="file-Text" v-if="item.type !== 'image'">{{ item.fileName }}</span>
                      </div>
                      <div class="mask">
                        <div class="mask-button">
                          <el-button @click="clearUpload(item)">重新上传</el-button>
                        </div>
                      </div>
                    </div>
                  </template>
                  <template v-else>
                    <div>
                      <i class="el-icon-upload"></i>
                      <div class="el-upload__text">点击上传</div>
                    </div>
                    <div slot="tip" class="el-upload__tip">{{ item.placeholder }}</div>
                  </template>
                </el-upload>
              </template>
            </el-form-item>
          </el-col>
        </el-row>
      </ContentBox>
    </el-form>
    <ContentBox class="content-box">
      <el-button @click="handleCancel">取消</el-button>
      <el-button type="primary" :loading="saveLoading" @click="handleSave">保存</el-button>
    </ContentBox>
  </div>
</template>

<script>
import SparkMD5 from 'spark-md5'
import defaultImg from '@/assets/images/zip.png'

export default {
  props: {
    mode: { type: String }
  },
  data() {
    return {
      defaultImg,
      form: {
        materialName: '',
        spaceId: '',
        description: '',
        materialPackageList: []
      },
      spaceList: [],
      saveLoading: false,
      webpWidth: undefined,
      webpHeight: undefined
    }
  },
  computed: {
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      this.getSpaceList()
    },
    getSpaceList() {
      this.$service.getMaterialSpaceList().then((data) => {
        if (data && data.length > 0) {
          this.spaceList = data
          this.handleChangeSpace()
        }
      })
    },
    handleChangeSpace(val) {
      if (val) {
        const space = this.spaceList.find(item => item.spaceId === val)
        const resourceTypeEnum = { video: -1, image: 0, zip: 1 }
        this.form.materialPackageList = (space.materialPackageList || []).map(item => {
          return {
            type: item.type,
            key: item.materialKey,
            name: item.name,
            required: item.required,
            value: item.type === 'multi_select' ? [] : '',
            status: '',
            percentage: 0,
            format: ['image', 'video', 'zip'].includes(item.type)
              ? item.format.split(',').map(it => `.${it},.${it.toUpperCase()}`).join(',')
              : '',
            replaceText: ['image', 'video', 'zip'].includes(item.type)
              ? item.format.split(',').map(it => `${it}`).join('/')
              : '',
            limitSize: item.size || 0,
            placeholder: item.placeholder,
            options: item.options ? JSON.parse(item.options) : [],
            checkRules: this.getCheckRules(item),
            resourceType: resourceTypeEnum[item.type]
          }
        })
      }
    },
    handleCancel() {
      this.$emit('go-back')
    },
    handleSave() {
      this.$refs.form.validate((valid) => {
        const params = this.buildApiParam(this.form)
        if (valid && params) {
          this.saveLoading = true
          this.$service.saveMaterialPackage(params).then((res) => {
            this.$message.success('保存成功！')
            this.saveLoading = false
            this.$emit('go-back')
          })
        }
      })
    },
    buildApiParam(form) {
      const materialList = []
      this.form.materialPackageList.forEach((item) => {
        if (item.value !== '' && item.value !== undefined) {
          materialList.push({
            positionCode: item.key,
            positionUrl: item.type === 'multi_select' ? item.value.join(',') : item.value,
            positionSize: item.size,
            positionMd5: item.md5,
            positionType: item.type
          })
        }
      })

      return {
        materialName: form.materialName,
        spaceId: form.spaceId,
        description: form.description,
        materialDatas: materialList
      }
    },
    uploadFile(paramsFile, item) {
      item.percentage = 0
      item.status = 'uploading'
      item.value = ''
      let fileReader = new FileReader()
      let dataFile = paramsFile.file
      let spark = new SparkMD5() // 创建md5对象（基于SparkMD5）
      fileReader.readAsBinaryString(dataFile)
      // 文件读取完毕之后的处理
      fileReader.onload = function (e) {
        spark.appendBinary(e.target.result)
        item.md5 = spark.end()
        const intervalId = setInterval(() => {
          if (item.percentage < 99) {
            item.percentage += 1
          }
        }, 1560)
        this.$service
          .materialPackageUpload({
            file: paramsFile.file,
            md5: item.md5,
            spaceId: this.form.spaceId,
            resourceType: item.resourceType,
            positionCode: item.key,
            width: this.webpWidth,
            height: this.webpHeight,
          })
          .then((data) => {
            if (data.success || data.code === '40000' || data.code === 0) {
              this.percentage = 100
              setTimeout(() => {
                item.status = 'success'
                item.value = data.data.positionUrl
                item.fileName = dataFile.name
                item.size = data.data.positionSize
                item.md5 = data.data.positionMd5
                window.clearInterval(intervalId)
              }, 300)
            } else {
              item.percentage = 0
              item.status = 'error'
              window.clearInterval(intervalId)
              this.$message.error(data.message)
            }
          })
          .catch((e) => {
            item.percentage = 0
            window.clearInterval(intervalId)
            item.status = 'error'
          })
      }.bind(this)
    },
    async beforeUploadFile(file, item) {
      if (file.type === 'image/webp') {
        const resolution = await this.getWebpResolution(file)
        this.webpWidth = resolution.width
        this.webpHeight = resolution.height
      } else {
        this.webpWidth = undefined
        this.webpHeight = undefined
      }

      return true
    },
    // 获取webp图片的分辨率
    getWebpResolution(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.readAsDataURL(file)
        reader.onload = function () {
          if (reader.readyState === 2) {
            const img = new Image()
            img.src = reader.result
            img.onload = function (e) {
              resolve({ width: this.width, height: this.height })
            }
          }
        }
      })
    },
    clearUpload() {},
    getCheckRules(item) {
      let rules = [{ required: item.required === 1, message: '此项必填', trigger: 'blur' }]
      if (!item.checkRule) {
        return rules
      }

      const checkRule = (['text', 'single_select', 'multi_select'].includes(item.type) && item.checkRule) ? JSON.parse(item.checkRule) : []
      const regexpEnum = {
        letternumeric: '^[A-Za-z0-9\u4e00-\u9fa5]+$',
        alphanumeric: '^[A-Za-z0-9]+$',
        number: '^[0-9]+$',
        // eslint-disable-next-line
        email: '^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$',
        // eslint-disable-next-line
        url: '^(((ht|f)tps?):\/\/)?([^!@#$%^&*?.\s-]([^!@#$%^&*?.\s]{0,63}[^!@#$%^&*?.\s])?\.)+[a-z]{2,6}\/?',
        custom: checkRule.regexp
      }
      rules.push({
        pattern: new RegExp(regexpEnum[checkRule.validationType]),
        message: checkRule.help,
        trigger: ['blur', 'change']
      })
      if (checkRule.validateLength) {
        rules.push({
          min: checkRule.minLength,
          max: checkRule.maxLength,
          message: checkRule.help,
          trigger: ['blur', 'change']
        })
      }
      if (checkRule.validationType === 'number' && checkRule.minRange !== undefined) {
        const checkMinRange = (rule, value, callback) => {
          if (value && parseFloat(value) < checkRule.minRange) {
            return callback(new Error(checkRule.help))
          }
          callback()
        }
        rules.push({ validator: checkMinRange, trigger: ['blur', 'change'] })
      }
      if (checkRule.validationType === 'number' && checkRule.maxRange !== undefined) {
        const checkMaxRange = (rule, value, callback) => {
          if (value && parseFloat(value) > checkRule.maxRange) {
            return callback(new Error(checkRule.help))
          }
          callback()
        }
        rules.push({ validator: checkMaxRange, trigger: ['blur', 'change'] })
      }

      return rules
    }
  }
}
</script>

<style lang="stylus" scoped>
.content-container
  margin 16px
  >>>.content-box__main
    margin-left 32px
    margin-top 32px
.mate-upload-box
  border 1px dashed #d9d9d9
  display flex
  flex-direction column
  justify-content center
  align-items center
  min-height 122px
  .mate-progress
    display flex
    padding 10px 0px
  .el-upload
    display block
    margin 10px
  .el-icon-upload
    font-size 40px
    width 52px
    height 43px
    color rgba(255, 139, 0, 0.5)
  .el-upload__text
    color #999
  .el-upload__tip
    color #999
    margin 0
.mask
  position absolute
  top 0
  left 0
  height 100%
  width 100%
  background rgba(101, 101, 101, 0.6)
  color #ffff f
  opacity 0
  .mask-button
    display flex
    height 100%
    justify-content center
    align-items center
.img-box
  position relative
  width 200px
  .show-img-box
    height 100%
    width 100%
    display flex
    flex-direction column
    align-items center
    img
      width 100%
.img-box:hover .mask
  opacity 1
.tts-tip
  padding-left 20px
  color #999
  font-size 14px
.inline-items
  display flex
  flex-flow row nowrap
.inline-tip
  padding-left 20px
  font-size 12px
  color #999
</style>
